import { MutationCache, QueryClient, QueryClientProvider } from "react-query";
import { isDashboardQuery } from "@factory/model/query-model-dashboard";
import { DateTimeProvider } from "@shared/utility/date-time-service/date-time.context";
import { NotificationProvider } from "@shared/ui/notification/notification.context";
import { AppRoute } from "./app.route";
import { PrimeReactProvider } from "primereact/api";
import { appConfig } from "./app.config";

const queryClient: QueryClient = new QueryClient({
  // Dashboard figures are cached for a short while (see dashboard.query.ts),
  // so any successful write - payment, discount, contract, patient, ... -
  // marks them stale and the next dashboard visit refetches.
  mutationCache: new MutationCache({
    onSuccess: () => {
      queryClient.invalidateQueries({ predicate: isDashboardQuery });
    },
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2,
    },
  },
});

function App() {
  const primeReactValue = {
    ripple: true,
  };

  return (
    <QueryClientProvider client={queryClient}>
      <PrimeReactProvider value={primeReactValue}>
        <DateTimeProvider
          dateFormat={appConfig.dateFormat}
          dateTimeFormat={appConfig.dateTimeFormat}
        >
          <NotificationProvider>
            <AppRoute />
          </NotificationProvider>
        </DateTimeProvider>
      </PrimeReactProvider>
    </QueryClientProvider>
  );
}

export default App;
